import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import * as Icons from "react-feather";
import AddVehicle from './AddVehicle';
import DeleteVehicle from './DeleteVehicle';
import ViewVehicle from './ViewVehicle';
import EditVehicle from './EditVehicle';
import VehicleModel from './models/VehicleModel';
import { logAuditEvent } from '../../utils/auditLogger';

function VehicleModal({onClose, onSubmit, UserAction, show, selectedRow, moduleName = 'Vehicle Entry'}) {
    const [childData, setChildData] = useState(new VehicleModel() || []);
    const [isSubmitting, setIsSubmitting] = useState(false);
    let modalAction;
    let showButtons;
    let userAction = reactStringReplace(UserAction, 'User', () => '');

    useEffect(() => {
        if (show && selectedRow) {
          setChildData({ ...selectedRow }); // create a new object to break reference
        } else if (!show) {
          setChildData(new VehicleModel()); // reset when closed
        }
    }, [selectedRow, show]);

    const handleDataFromChild = (data) => {
        setChildData(data);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;
        setIsSubmitting(true);
        const actionDescriptor = (UserAction === 'Delete') ? 'Delete Confirm' : 'Save';
        logAuditEvent(moduleName, `${UserAction || 'Action'} ${actionDescriptor}`, `${actionDescriptor} clicked`);
        try {
            await onSubmit(e, childData);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = (label) => {
        logAuditEvent(moduleName, `${UserAction || 'Action'} ${label}`, `${label} clicked`);
        onClose();
    };

    const handleLoad = (data) => {
        setChildData(data); // Send the form data back to the parent component
    };
    if(UserAction === "Add"){
        modalAction = <AddVehicle  onLoad= {handleLoad} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Add" onClick={() => handleCancel('Cancel')} disabled={isSubmitting}>Cancel</button>
                            <button className="btn btn-submit" name="Add" onClick={handleSubmit} disabled={isSubmitting}>{isSubmitting ? 'Submitting...' : 'Submit'}</button>
                    </div>
    } else if(UserAction === "Edit"){
        modalAction = <EditVehicle VehicleData={childData} onSubmit= {onSubmit} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Edit" onClick={() => handleCancel('Cancel')} disabled={isSubmitting}>Cancel</button>
                            <button className="btn btn-submit" name="Edit" onClick={handleSubmit} disabled={isSubmitting}>{isSubmitting ? 'Submitting...' : 'Submit'}</button>
                    </div>
    } else if(UserAction === "View"){
        modalAction = <ViewVehicle VehicleData={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="View" onClick={() => handleCancel('Close')}>Cancel</button>
                    </div>
    } else if(UserAction === "Delete"){
        modalAction = <DeleteVehicle VehicleData={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={() => handleCancel('Delete Cancel')} disabled={isSubmitting}>Cancel</button>
                            <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit} disabled={isSubmitting}>{isSubmitting ? 'Deleting...' : 'Delete'}</button>
                    </div>
    }
  return (
    UserAction !== "Delete" ?
            <Modal
                show={show}
                onHide={() => handleCancel('Close')}
                backdrop="static"
                size="lg"
            >
                <ModalHeader className="modal-header border-0 custom-modal-header" >
                    <ModalTitle >{userAction} Vehicle Entry</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="">
                    {showButtons}
                </ModalFooter>
            </Modal> 
        :   <Modal
            show={show}
            onHide={() => handleCancel('Close')}
                backdrop="static"            >
           
                <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
                    <ModalTitle>
                        <div className="custom-alert-icon">
                            <Icons.AlertOctagon className="flex-shrink-0"/>
                        </div>
                        <div > {userAction} Vehicle Entry</div>
                    </ModalTitle>
                </ModalHeader>
                
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter>
                    {showButtons}
                </ModalFooter>
            </Modal>
  );
}

export default VehicleModal;
